import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDeleteLegalClientBeneficiaryMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

interface Args {
  id: string;
  reason: string;
  versionNumber: number;
}

export const useDeleteLegalClientBeneficiary = () => {
  const [handle, { loading, error: apolloError }] =
    useDeleteLegalClientBeneficiaryMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    deleteLegalClientBeneficiary: useCallback(
      async (input: Args) => {
        const res = await handle({ variables: input });
        return res.data?.deleteLegalClientBeneficiary;
      },
      [handle]
    ),
  };
};
